export default {
  temPendencia: state => state.temPendencia,
  pendenciaAtual: state => state.pendenciaAtual
};
